<template>
    <div id="page" class="page">

        <interne_menu></interne_menu>
               
        <!-- Mentions legales -->
        <section id="faqs-1" class="bg-fixed bg-lightgrey wide-60 faqs-section division contact-bck">						
            <div class="container">


                <!-- SECTION TITLE -->	
                <div class="row">	
                    <div class="col-md-10 offset-md-1 section-title">	

                        <!-- Title 	-->	
                        <div class="l_weblogy"><img src="@/assets/images/logo-weblogy.webp" class="img_weblogy"></div>

                        <!-- Title 	-->	
                        <h2 class="h2-lg">A PROPOS DE WEBLOGY</h2>	
                        
                                
                    </div> 	 <!-- End row --> 	
                </div>	 <!-- END SECTION TITLE -->	

                <div class="row">
                    
                    <!-- QUESTIONS HOLDER -->
                    <div class="col-lg-6">
                        <div class="questions-holder ind-30">


                            <!-- QUESTION #5 -->
                            <div class="question animated fadeInUp visible" data-animation="fadeInUp" data-animation-delay="300">                                                       

                                <p><span class="wby">W</span><span class="wbye">e</span><span class="wby">blogy</span>, fintech et groupe média digital indépendant créé en 1998, s’est donné pour mission d'accélérer la transformation digitale en
                                 Afrique en offrant un mélange unique de créativité et d’expertise marketing digital.</p>
                                
                                 <p>Nous sommes aussi éditeur d’applications mobiles Android et Apple, et de sites internet et E-commerce. 
                                Nous créons des interfaces conviviales, et concevons des campagnes internet, génératrices de profits commerciaux indiscutables et de rapides retours sur investissement.</p>
                                
                                <p>Depuis plus de 20 ans, <strong>avons exécuté plus de 3 000 projets internet et mobile</strong>  avec un portefeuille de plus de <strong>700 clients dans le monde.</strong> 
                                Nous disposons aujourd’hui d’un réseau publicitaire indépendant des 100 meilleurs sites africains couvrant <strong>48 pays avec plus de 20 millions visiteurs uniques par mois.</strong></p>

                            </div>	

                            


                            <!-- QUESTION #7 -->
                            <div class="question animated fadeInUp visible" data-animation="fadeInUp" data-animation-delay="600">

                                <!-- Answer -->
                                <p>Nous sommes présents dans 10 pays à travers: 5 bureaux et 5 représentations commerciales avec plus de 150 collaborateurs.</p>
           
                                <!-- Text -->	
                                <div class="box-list m-top-15 animated fadeInLeft visible" data-animation="fadeInLeft" data-animation-delay="600">					
                                    <div class="box-list-icon"><svg class="svg-inline--fa fa-genderless fa-w-9 orange" aria-hidden="true" data-prefix="fas" data-icon="genderless" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 288 512" data-fa-i2svg=""><path fill="currentColor" d="M144 176c44.1 0 80 35.9 80 80s-35.9 80-80 80-80-35.9-80-80 35.9-80 80-80m0-64C64.5 112 0 176.5 0 256s64.5 144 144 144 144-64.5 144-144-64.5-144-144-144z"></path></svg><!-- <i class="fas fa-genderless"></i> --></div>
                                    <p>Une connaissance et une maîtrise étendues des nouvelles technologies de communication</p>							
                                </div>

                                <!-- Text -->	
                                <div class="box-list m-top-15 animated fadeInLeft visible" data-animation="fadeInLeft" data-animation-delay="600">					
                                    <div class="box-list-icon"><svg class="svg-inline--fa fa-genderless fa-w-9 orange" aria-hidden="true" data-prefix="fas" data-icon="genderless" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 288 512" data-fa-i2svg=""><path fill="currentColor" d="M144 176c44.1 0 80 35.9 80 80s-35.9 80-80 80-80-35.9-80-80 35.9-80 80-80m0-64C64.5 112 0 176.5 0 256s64.5 144 144 144 144-64.5 144-144-64.5-144-144-144z"></path></svg><!-- <i class="fas fa-genderless"></i> --></div>
                                    <p>Notre capacité d'écoute, force de proposition et veille technologique constante</p>							
                                </div>
                                <!-- Text -->	
                                <div class="box-list m-top-15 animated fadeInLeft visible" data-animation="fadeInLeft" data-animation-delay="600">					
                                    <div class="box-list-icon"><svg class="svg-inline--fa fa-genderless fa-w-9 orange" aria-hidden="true" data-prefix="fas" data-icon="genderless" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 288 512" data-fa-i2svg=""><path fill="currentColor" d="M144 176c44.1 0 80 35.9 80 80s-35.9 80-80 80-80-35.9-80-80 35.9-80 80-80m0-64C64.5 112 0 176.5 0 256s64.5 144 144 144 144-64.5 144-144-64.5-144-144-144z"></path></svg><!-- <i class="fas fa-genderless"></i> --></div>
                                    <p>Notre structure souple, efficace et réactive</p>							
                                </div>
                                <!-- Text -->	
                                <div class="box-list m-top-15 animated fadeInLeft visible" data-animation="fadeInLeft" data-animation-delay="600">					
                                    <div class="box-list-icon"><svg class="svg-inline--fa fa-genderless fa-w-9 orange" aria-hidden="true" data-prefix="fas" data-icon="genderless" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 288 512" data-fa-i2svg=""><path fill="currentColor" d="M144 176c44.1 0 80 35.9 80 80s-35.9 80-80 80-80-35.9-80-80 35.9-80 80-80m0-64C64.5 112 0 176.5 0 256s64.5 144 144 144 144-64.5 144-144-64.5-144-144-144z"></path></svg><!-- <i class="fas fa-genderless"></i> --></div>
                                    <p>La diversité de nos ressources humaines</p>							
                                </div>
                                <!-- Text -->	
                                <div class="box-list m-top-15 animated fadeInLeft visible" data-animation="fadeInLeft" data-animation-delay="600">					
                                    <div class="box-list-icon"><svg class="svg-inline--fa fa-genderless fa-w-9 orange" aria-hidden="true" data-prefix="fas" data-icon="genderless" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 288 512" data-fa-i2svg=""><path fill="currentColor" d="M144 176c44.1 0 80 35.9 80 80s-35.9 80-80 80-80-35.9-80-80 35.9-80 80-80m0-64C64.5 112 0 176.5 0 256s64.5 144 144 144 144-64.5 144-144-64.5-144-144-144z"></path></svg><!-- <i class="fas fa-genderless"></i> --></div>
                                    <p>Nous assurons l’excellence et la cohérence tout au long de la chaîne de valeur</p>							
                                </div>




                                <!-- Title -->	
                                <h5 class="h5-md animated fadeInRight visible" data-animation="fadeInRight" data-animation-delay="500"><br>
                                    Notre Vision
                                </h5>
                                                
                                <p>Nous désirons aider les pays africains en voie de développement grâce aux nouvelles technologies. C’est pourquoi nous sommes en veille continue sur
                                     les dernières innovations du monde de l'internet. Nous vous proposons un mélange unique de créativité et d'expertise marketing dans les médias Internet,
                                      mobile, et réseaux sociaux pour offrir le meilleur de l'internet en Afrique aux internautes du monde entier.</p>

                                <p>Votre succès reste au coeur de nos réflexions. Nous nous assurons de construire une relation durable avec vous basée sur la confiance mutuelle. Nos équipes
                                     de professionnelles passionnées et efficaces restent à votre écoute pour définir un positionnement internet adapté. Notre méthodologie se résume dans une
                                     approche sur mesure de vos besoins et une excellence dans l'exécution des projets que vous nous confiez.</p>  
                                                                    
                               

                            </div>	


                        </div>
                    </div>	<!-- END  QUESTIONS HOLDER -->

                    <!-- QUESTIONS HOLDER -->
                    <div class="col-lg-6">
                        <div class="questions-holder ind-30">


                            <!-- QUESTION #1 -->
                            <div class="question animated fadeInUp visible" data-animation="fadeInUp" data-animation-delay="300">

                                <p>
                                    <img src="@/assets/images/illust_weblogy.webp" class="ill_web">
                                </p>

                            </div>	


                        </div>
                    </div>	<!-- END QUESTIONS HOLDER -->


                </div>	<!-- End row -->		



            </div>	   <!-- End container -->		
			</section>
        <!-- Mentions legales -->

       

        <footer_menu></footer_menu>
    </div>

</template>

<script>
import interne_menu  from '../components/interne_menu.vue';
import footer_menu  from '../components/footer_menu.vue';
export default{
    name :'nos_cartes',
    components:{
      'interne_menu' :interne_menu,
      'footer_menu' :footer_menu
    } 
}


</script>

<style scoped>
.pro_part{
    background: url(@/assets/images/pic-pro-interne.png) no-repeat;   
}
.sct_bck{
    background: url(@/assets/images/95b26da8.png) no-repeat;   
}
.wide-60 {
    padding-top: 190px;
    padding-bottom: 60px;
}
.btn-lightorange {
    color: #fff;
    background-color: #ff9e00;
    border-color: #f3a72e;
}
#download-2 .bg-inner {
    /* background-image: url(../images/download-2.jpg); */
    position: relative;
    z-index: 1;
    background: #261b64;
}
.orange{
color: #ff9e00;
}
.h5-sm{
    color: #261b64;
}
.l_weblogy{
    width: 300px;
    height: 300px;
    border: 4px solid #fff;
    margin: auto;
    border-radius: 50%;
    margin-bottom: 20px;
}
.img_weblogy{
max-width: 222px;
text-align: center;
margin-top: 120px;
}
.wby {
    font-family: ErasBookC;
    font-weight: bold;
    color: #000000;
}
.wbye {
    font-family: ErasBookC;
    text-decoration: underline;
    color: #fa0201;
    font-weight: bold;
}
.ill_web{
   max-width: 570px; 
}
</style>

